
export default {
  props: {
    track: { type: Object, required: true },
    dayStart: { type: Number, required: true },
    dayDuration: { type: Number, required: true },
    pxPerSec: { type: Number, required: true },
    tracksWidth: { type: Number, required: true },
  },
}
